export const productionTargetMessages = {
	MSG_ERROR_LOADING: 'Ocorreu um erro, tente novamente!',
	MSG_ERROR_PRODUCTION_TARGET_NOT_AVAILABLE:
		'Dados de metas de produção não disponíveis',

	LABELS: {
		YEAR: 'Ano',
		MONTH: 'Mês',
		AVAILABILITY: 'DISPONIBILIDADE',
		PERFORMANCE: 'PERFORMANCE',
		QUALITY: 'QUALIDADE',
		IROG: 'IROG',
		CANCEL: 'Cancelar',
		SAVE: 'Salvar',
		UPDATE_PRODUCTION_TARGET: 'Atualizar Meta de Produção Anual',
		SAVE_FOR_SELECTED_MONTH: 'Não, salvar só para mês selecionado',
		SAVE_FOR_YEAR: 'Sim',
	},

	MONTHS: {
		JANUARY: 'Janeiro',
		FEBRUARY: 'Fevereiro',
		MARCH: 'Março',
		APRIL: 'Abril',
		MAY: 'Maio',
		JUNE: 'Junho',
		JULY: 'Julho',
		AUGUST: 'Agosto',
		SEPTEMBER: 'Setembro',
		OCTOBER: 'Outubro',
		NOVEMBER: 'Novembro',
		DECEMBER: 'Dezembro',
	},

	MODAL: {
		UPDATE_ANNUAL_PRODUCTION_TARGET: 'Atualizar Meta de Produção Anual',
		UPDATE_FUTURE_MONTHS_QUESTION:
			'Você deseja atualizar este mesmo valor para todos os meses futuros do ano selecionado?',
	},

	SCREEN_TITLES: {
		PRODUCTION_TARGETS: 'Metas',
	},
} as const;

export type ProductionTargetMessageType =
	(typeof productionTargetMessages)[keyof typeof productionTargetMessages];
